import React from 'react';
import './PageWithCards.scss';
function PageWithCards({ children }) {
    return (React.createElement("div", { className: "page-with-cards" },
        React.createElement("div", { className: "page-with-cards__card-container" }, children)));
}
export default PageWithCards;
